export const featuredAnime = [
  {
    id: '1',
    title: '鬼灭之刃 柱训练篇',
    titleEn: 'Demon Slayer: Hashira Training Arc',
    category: '日漫',
    rating: 9.7,
    views: '2.3亿',
    episodes: 8,
    status: '连载中',
    description: '炭治郎为了变强，与同伴们一起参加了由鬼杀队九柱主持的严酷训练。在新的挑战面前，他们将迎来实力的飞跃。',
    imageSeq: 'anime-featured-01',
    tags: ['热血', '战斗', '奇幻'],
    releaseDate: '2024-05',
  },
  {
    id: '2',
    title: '咒术回战 第二季',
    titleEn: 'Jujutsu Kaisen Season 2',
    category: '日漫',
    rating: 9.5,
    views: '1.8亿',
    episodes: 23,
    status: '已完结',
    description: '五条悟与夏油杰的过去被揭开，涩谷事变中咒术师与咒灵展开激烈对决。',
    imageSeq: 'anime-featured-02',
    tags: ['热血', '战斗', '超能力'],
    releaseDate: '2023-07',
  },
  {
    id: '3',
    title: '葬送的芙莉莲',
    titleEn: 'Frieren: Beyond Journey\'s End',
    category: '日漫',
    rating: 9.8,
    views: '1.5亿',
    episodes: 28,
    status: '已完结',
    description: '勇者一行人打倒魔王之后，精灵魔法使芙莉莲踏上了理解人类的旅程。',
    imageSeq: 'anime-featured-03',
    tags: ['奇幻', '冒险', '治愈'],
    releaseDate: '2023-09',
  },
  {
    id: '4',
    title: '我推的孩子',
    titleEn: 'Oshi no Ko',
    category: '日漫',
    rating: 9.3,
    views: '1.2亿',
    episodes: 11,
    status: '已完结',
    description: '演艺圈的爱与谎言，一个关于偶像与粉丝之间命运交织的故事。',
    imageSeq: 'anime-featured-04',
    tags: ['偶像', '悬疑', '剧情'],
    releaseDate: '2023-04',
  },
  {
    id: '5',
    title: '仙王的日常生活 第四季',
    titleEn: 'The Daily Life of the Immortal King S4',
    category: '国漫',
    rating: 8.9,
    views: '9800万',
    episodes: 12,
    status: '已完结',
    description: '王令继续在修仙高中过着看似平凡实则惊心动魄的日常生活。',
    imageSeq: 'anime-featured-05',
    tags: ['搞笑', '修仙', '校园'],
    releaseDate: '2024-01',
  },
  {
    id: '6',
    title: '完美世界',
    titleEn: 'Perfect World',
    category: '国漫',
    rating: 9.2,
    views: '3.5亿',
    episodes: 182,
    status: '连载中',
    description: '石昊在乱世中崛起，一路披荆斩棘，成为真正至尊的传奇故事。',
    imageSeq: 'anime-featured-06',
    tags: ['玄幻', '热血', '修仙'],
    releaseDate: '2021-04',
  },
];

export const categories = [
  { id: 'japanese', name: '日漫精选', slug: 'japanese', icon: 'ri-sun-line', count: 1280, description: '最新最热的日本动漫番剧' },
  { id: 'chinese', name: '国漫专区', slug: 'chinese', icon: 'ri-china-railway-line', count: 860, description: '优质国产动漫作品' },
  { id: 'hot', name: '热门新番', slug: 'hot', icon: 'ri-fire-line', count: 356, description: '当季热播新番推荐' },
  { id: 'classic', name: '经典老番', slug: 'classic', icon: 'ri-vip-crown-line', count: 520, description: '不可错过的经典动漫' },
  { id: 'movie', name: '剧场版', slug: 'movie', icon: 'ri-film-line', count: 180, description: '动漫剧场版电影合集' },
  { id: 'ova', name: 'OVA/OAD', slug: 'ova', icon: 'ri-dvd-line', count: 95, description: '原创动画视频特典' },
];

export const latestArticles = [
  {
    id: 'a1',
    title: '2025年夏季新番导览：这些番剧值得期待',
    summary: '夏季新番强势来袭！从热血战斗到温馨日常，我们为你精选了本季最值得追的10部番剧。',
    category: '新番导览',
    date: '2025-08-08',
    imageSeq: 'article-01',
    author: '奶片编辑部',
  },
  {
    id: 'a2',
    title: '《鬼灭之刃》无限城篇：剧场版三部曲制作决定',
    summary: '官方正式宣布无限城篇将以三部剧场版的形式呈现，第一弹将于2025年上映。',
    category: '动漫资讯',
    date: '2025-08-05',
    imageSeq: 'article-02',
    author: '奶片编辑部',
  },
  {
    id: 'a3',
    title: '国漫崛起：《完美世界》播放量突破100亿',
    summary: '《完美世界》动画累计播放量突破100亿大关，成为国漫史上又一里程碑。',
    category: '国漫动态',
    date: '2025-08-03',
    imageSeq: 'article-03',
    author: '奶片编辑部',
  },
  {
    id: 'a4',
    title: '二次元入门指南：5部必看的经典动漫推荐',
    summary: '刚入坑二次元不知道该看什么？这份入门片单带你快速找到属于自己的本命番。',
    category: '番剧推荐',
    date: '2025-07-28',
    imageSeq: 'article-04',
    author: '奶片编辑部',
  },
  {
    id: 'a5',
    title: '《咒术回战》漫画最终话：粉丝反应与剧情解析',
    summary: '咒术回战漫画迎来最终话，我们整理了全球粉丝的反应以及剧情深度解析。',
    category: '动漫资讯',
    date: '2025-07-25',
    imageSeq: 'article-05',
    author: '奶片编辑部',
  },
];

export const faqData = [
  {
    question: '奶片动漫可以免费观看吗？',
    answer: '奶片动漫提供大量免费动漫资源，部分最新番剧和新番抢先看可能需要会员权限。我们致力于为动漫爱好者提供优质的观看体验，同时支持正版内容。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '奶片动漫支持PC网页端、移动端网页以及平板设备观看。只需浏览器即可访问，无需下载额外软件。所有设备均可享受高清流畅的播放体验。',
  },
  {
    question: '新番更新速度怎么样？',
    answer: '我们与日本及国内的动漫版权方保持紧密合作，热门新番通常在日本播出后的24小时内完成翻译并上线，确保你不错过任何精彩内容。',
  },
  {
    question: '如何查找我想看的动漫？',
    answer: '你可以通过顶部的搜索框直接搜索动漫名称，也可以按分类浏览（日漫、国漫、剧场版等），或查看我们的热门推荐和排行榜快速找到感兴趣的内容。',
  },
  {
    question: '画面卡顿或加载慢怎么办？',
    answer: '建议检查你的网络连接，或尝试切换播放清晰度。奶片动漫采用CDN加速技术，确保全国各地的用户都能获得流畅的播放体验。如仍有问题，可联系客服协助处理。',
  },
  {
    question: '如何联系客服？',
    answer: '你可以通过"关于我们"页面找到联系方式，包括客服邮箱和在线反馈表单。我们的客服团队将在24小时内回复你的问题。',
  },
];

export const animeByCategory: Record<string, typeof featuredAnime> = {
  japanese: featuredAnime.filter(a => a.category === '日漫'),
  chinese: featuredAnime.filter(a => a.category === '国漫'),
  hot: featuredAnime.filter(a => a.status === '连载中'),
  classic: [
    {
      id: 'c1', title: '钢之炼金术师 FA', titleEn: 'Fullmetal Alchemist: Brotherhood', category: '日漫',
      rating: 9.9, views: '8000万', episodes: 64, status: '已完结',
      description: '爱德华和阿尔冯斯兄弟为找回失去的东西，踏上了寻找贤者之石的旅程。',
      imageSeq: 'anime-classic-01', tags: ['冒险', '奇幻', '剧情'], releaseDate: '2009-04',
    },
    {
      id: 'c2', title: 'CLANNAD', titleEn: 'CLANNAD', category: '日漫',
      rating: 9.6, views: '5000万', episodes: 23, status: '已完结',
      description: '冈崎朋也在光坂高校与古河渚相遇，展开了一段温馨而感人的人生故事。',
      imageSeq: 'anime-classic-02', tags: ['治愈', '校园', '恋爱'], releaseDate: '2007-10',
    },
    {
      id: 'c3', title: '命运石之门', titleEn: 'Steins;Gate', category: '日漫',
      rating: 9.7, views: '4500万', episodes: 24, status: '已完结',
      description: '冈部伦太郎偶然发明了时间机器，随之而来的是无尽的命运轮回。',
      imageSeq: 'anime-classic-03', tags: ['科幻', '悬疑', '剧情'], releaseDate: '2011-04',
    },
    {
      id: 'c4', title: '星际牛仔', titleEn: 'Cowboy Bebop', category: '日漫',
      rating: 9.5, views: '3500万', episodes: 26, status: '已完结',
      description: '2071年，赏金猎人Spike和Jet在宇宙中追逐罪犯的太空冒险故事。',
      imageSeq: 'anime-classic-04', tags: ['科幻', '动作', '爵士'], releaseDate: '1998-04',
    },
    {
      id: 'c5', title: '虫师', titleEn: 'Mushishi', category: '日漫',
      rating: 9.4, views: '2000万', episodes: 26, status: '已完结',
      description: '虫师银古游历各地，解决由"虫"引起的各种神秘现象。',
      imageSeq: 'anime-classic-05', tags: ['奇幻', '治愈', '哲理'], releaseDate: '2005-10',
    },
    {
      id: 'c6', title: '龙与虎', titleEn: 'Toradora!', category: '日漫',
      rating: 9.2, views: '2800万', episodes: 25, status: '已完结',
      description: '看似凶恶的龙儿和娇小的"掌中老虎"大河，一段青春恋爱喜剧。',
      imageSeq: 'anime-classic-06', tags: ['恋爱', '校园', '喜剧'], releaseDate: '2008-10',
    },
  ],
  movie: [
    {
      id: 'm1', title: '你的名字。', titleEn: 'Your Name.', category: '日漫',
      rating: 9.4, views: '1.2亿', episodes: 1, status: '已完结',
      description: '东京男生泷与乡下女生三叶在梦中交换身体，展开跨越时空的恋爱故事。',
      imageSeq: 'anime-movie-01', tags: ['恋爱', '奇幻', '青春'], releaseDate: '2016-08',
    },
    {
      id: 'm2', title: '千与千寻', titleEn: 'Spirited Away', category: '日漫',
      rating: 9.8, views: '2.5亿', episodes: 1, status: '已完结',
      description: '少女千寻误入神灵世界，为救父母在汤屋工作，经历了一场奇幻冒险。',
      imageSeq: 'anime-movie-02', tags: ['奇幻', '冒险', '成长'], releaseDate: '2001-07',
    },
    {
      id: 'm3', title: '天气之子', titleEn: 'Weathering With You', category: '日漫',
      rating: 8.8, views: '8000万', episodes: 1, status: '已完结',
      description: '离家出走的少年帆高遇见了能操控天气的少女阳菜，一段关于选择的物语。',
      imageSeq: 'anime-movie-03', tags: ['恋爱', '奇幻', '青春'], releaseDate: '2019-07',
    },
    {
      id: 'm4', title: '鬼灭之刃 无限列车', titleEn: 'Mugen Train', category: '日漫',
      rating: 9.6, views: '1.5亿', episodes: 1, status: '已完结',
      description: '炭治郎等人登上无限列车，与炎柱炼狱杏寿郎并肩对抗强大的恶鬼。',
      imageSeq: 'anime-movie-04', tags: ['热血', '战斗', '奇幻'], releaseDate: '2020-10',
    },
  ],
  ova: [
    {
      id: 'o1', title: '进击的巨人 OAD', titleEn: 'Attack on Titan OAD', category: '日漫',
      rating: 9.1, views: '3000万', episodes: 8, status: '已完结',
      description: '进击的巨人系列原创动画DVD特典，补充正篇未讲述的精彩故事。',
      imageSeq: 'anime-ova-01', tags: ['动作', '奇幻', '黑暗'], releaseDate: '2013-12',
    },
    {
      id: 'o2', title: 'Fate/Zero OVA', titleEn: 'Fate/Zero OVA', category: '日漫',
      rating: 9.0, views: '2500万', episodes: 2, status: '已完结',
      description: '第四次圣杯战争的幕后故事，揭示更多关于英灵与御主的秘密。',
      imageSeq: 'anime-ova-02', tags: ['战斗', '奇幻', '剧情'], releaseDate: '2012-03',
    },
  ],
};

export const articleContent: Record<string, {
  title: string;
  category: string;
  date: string;
  author: string;
  content: string[];
  tags: string[];
  imageSeq: string;
}> = {
  'a1': {
    title: '2025年夏季新番导览：这些番剧值得期待',
    category: '新番导览',
    date: '2025-08-08',
    author: '奶片编辑部',
    imageSeq: 'article-01',
    tags: ['夏季新番', '番剧推荐', '2025'],
    content: [
      '随着2025年夏季的到来，又一批令人期待的新番即将上线。本季新番阵容强大，涵盖了热血战斗、温馨日常、奇幻冒险等多种类型，无论你是哪种口味的动漫迷，都能找到属于自己的那部本命番。',
      '首先值得关注的是《咒术回战》的续作篇章。作为近年来最火爆的少年漫改动画，本季将继续展开涩谷事变之后的剧情，更多强大的咒术师和咒灵将登场亮相。MAPPA的制作水准一向稳定，动作场面令人期待。',
      '此外，轻小说改编的《转生成为史莱姆的那件事》新一季也将登场。利姆鲁的建国之路继续推进，更多新角色加入，剧情进入更加宏大的篇章。轻松愉快的氛围配合精彩的战斗场面，是本季不容错过的作品。',
      '原创动画方面，《Vivy》制作团队带来的全新原创作品备受瞩目。虽然目前公布的细节不多，但从PV来看，其制作质量和剧情深度都值得期待。原创动画的魅力在于你永远不知道下一集会发生什么。',
      '国漫方面，《凡人修仙传》新篇章继续更新，韩立的故事进入新阶段。精美的3D制作和紧凑的剧情节奏，让这部作品在国漫爱好者中收获了大量好评。另外《斗破苍穹》年番也持续稳定更新中。',
      '对于喜欢轻松日常的朋友，本季也有多部校园恋爱和搞笑日常番值得关注。这类作品虽然不追求宏大的剧情，但细腻的情感描写和轻松的氛围往往更能打动人心。',
      '总的来说，2025年夏季新番可谓是百花齐放。我们建议大家可以根据自己的喜好类型，每周固定追2-3部番，这样既不会太累，也能充分享受追番的乐趣。奶片动漫将持续为大家提供最新最快的番剧更新，敬请期待！',
    ],
  },
  'a2': {
    title: '《鬼灭之刃》无限城篇：剧场版三部曲制作决定',
    category: '动漫资讯',
    date: '2025-08-05',
    author: '奶片编辑部',
    imageSeq: 'article-02',
    tags: ['鬼灭之刃', '剧场版', '无限城篇'],
    content: [
      '《鬼灭之刃》官方正式宣布，原作漫画中备受粉丝期待的"无限城篇"将以剧场版三部曲的形式呈现。这一消息在动漫圈引起了巨大反响，无数粉丝为之激动不已。',
      '根据官方发布的信息，三部剧场版将完整覆盖原作漫画中无限城篇的全部内容。第一部预计将于2025年冬季上映，后续两部分别计划在2026年和2027年推出。',
      '无限城篇是《鬼灭之刃》漫画中最为宏大和精彩的篇章之一。在这一篇章中，鬼杀队的柱们将与上弦之鬼展开最终的决战，无数角色将迎来命运的转折点。这个篇章的战斗场面极其精彩，角色塑造也达到了新的高度。',
      '制作方ufotable表示，将以最高规格的制作水准来完成这组剧场版三部曲。作为以精美作画和华丽特效闻名的动画工作室，ufotable此前制作的《鬼灭之刃 无限列车》剧场版就创下了日本影史票房纪录，全球票房超过5亿美元。',
      '粉丝们对剧场版三部曲的期待值极高。在社交媒体上，关于无限城篇剧情、角色和战斗场面的讨论已经成为热门话题。许多粉丝表示，虽然担心等待时间较长，但为了看到高质量的作品，愿意耐心等待。',
      '奶片动漫将持续关注《鬼灭之刃》无限城篇剧场版的最新动态，为大家带来第一手的资讯报道。',
    ],
  },
  'a3': {
    title: '国漫崛起：《完美世界》播放量突破100亿',
    category: '国漫动态',
    date: '2025-08-03',
    author: '奶片编辑部',
    imageSeq: 'article-03',
    tags: ['完美世界', '国漫', '播放量'],
    content: [
      '国产动画《完美世界》官方宣布，该作品累计播放量正式突破100亿大关，成为国漫史上又一座重要的里程碑。这一成就不仅证明了作品本身的优秀品质，也标志着国漫产业进入了新的发展阶段。',
      '《完美世界》改编自辰东的同名网络小说，讲述了少年石昊在浩大的修真世界中不断成长、最终成为至尊的故事。动画于2021年4月开播，至今已播出超过180集，以其精良的3D制作和紧凑的剧情节奏赢得了广泛好评。',
      '近年来，国漫产业发展迅速。《完美世界》、《斗罗大陆》、《凡人修仙传》等作品的相继成功，证明了国产动画在制作水平和市场接受度上都达到了新的高度。越来越多的优秀国漫作品正在涌现，为观众提供了丰富的选择。',
      '业内人士分析认为，《完美世界》播放量突破100亿的背后，反映了中国动漫市场的巨大潜力。随着制作技术的不断提升和内容创作的日趋成熟，国漫正在从"追赶者"转变为行业的"引领者"之一。',
      '在奶片动漫平台上，《完美世界》也一直是最受欢迎的国漫作品之一。我们很高兴看到国漫取得如此亮眼的成绩，期待未来有更多优秀的国产动漫作品问世。',
    ],
  },
  'a4': {
    title: '二次元入门指南：5部必看的经典动漫推荐',
    category: '番剧推荐',
    date: '2025-07-28',
    author: '奶片编辑部',
    imageSeq: 'article-04',
    tags: ['入门推荐', '经典动漫', '二次元'],
    content: [
      '刚接触二次元世界，面对浩如烟海的动漫作品不知从何看起？别担心，我们为你精心挑选了5部不同类型的经典之作，覆盖了热血、治愈、悬疑、恋爱等多种风格，帮你快速找到属于自己的本命番。',
      '第一推荐：《钢之炼金术师FA》。这部作品被誉为"零差评神作"，无论是剧情逻辑、角色塑造还是主题深度都达到了极致。兄弟之情、等价交换的原则贯穿始终，64集一气呵成，是动漫入门的绝佳选择。',
      '第二推荐：《命运石之门》。如果你喜欢烧脑的科幻悬疑，这部作品绝对不容错过。前半部分铺垫稍慢，但一旦进入主线，剧情的反转和情感的冲击力会让你欲罢不能。时间旅行的设定充满了科学感和哲学思考。',
      '第三推荐：《排球少年！！》。这是一部让人热血沸腾的运动番。即使你对排球一无所知，也能被角色们的拼搏精神和团队情谊深深打动。精彩的比赛场面和细腻的人物刻画，让它成为运动番的天花板。',
      '第四推荐：《紫罗兰永恒花园》。京都动画出品的视觉盛宴，每一帧都美得像一幅画。故事讲述战后少女薇尔莉特通过代笔书信理解"爱"的含义，是一部温暖治愈又催泪的作品。',
      '第五推荐：《你的名字。》。新海诚导演的代表作，将青春恋爱与奇幻元素完美融合。精美的画面、动人的配乐、跨越时空的爱情故事，让它成为现象级的动画电影。',
      '这5部作品涵盖了不同的风格和类型，相信总有一部能够打动你。看完这些之后，你还可以在奶片动漫上根据分类和推荐发现更多好番，开启属于自己的追番之旅！',
    ],
  },
  'a5': {
    title: '《咒术回战》漫画最终话：粉丝反应与剧情解析',
    category: '动漫资讯',
    date: '2025-07-25',
    author: '奶片编辑部',
    imageSeq: 'article-05',
    tags: ['咒术回战', '漫画完结', '剧情解析'],
    content: [
      '备受瞩目的《咒术回战》漫画正式迎来了最终话。这部由芥见下下创作的暗黑战斗漫画，自2018年开始连载以来，以其独特的世界观和紧凑的战斗场面吸引了全球大量粉丝。',
      '最终话中，虎杖悠仁、伏黑惠和钉崎野蔷薇三位主角终于迎来各自命运的结局。芥见老师用充满张力的画面和细腻的情感描写，为这个长达数年的故事画上了句号。',
      '粉丝反应两极分化明显。一部分粉丝对结局表示满意，认为角色的命运安排合理且有深意；另一部分粉丝则对某些角色的结局感到遗憾，希望看到不同的发展。社交媒体上关于结局的讨论热度持续高涨。',
      '从剧情角度来看，最终篇章保持了《咒术回战》一贯的风格：残酷而真实。芥见下下没有选择讨好式的圆满结局，而是让每个角色都面对自己选择的后果。这种叙事风格虽然在商业上冒险，但在艺术表达上无疑是勇敢的。',
      '虽然漫画已经完结，但《咒术回战》的动画版仍在继续制作中。MAPPA将继续负责动画制作，后续篇章预计将在未来几年陆续播出。对于动画党来说，精彩的故事才刚刚开始。',
      '奶片动漫将一如既往地为大家带来《咒术回战》动画及周边资讯的更新，请持续关注！',
    ],
  },
};

export const siteInfo = {
  name: '奶片动漫',
  englishName: 'Naipian Anime',
  slogan: '你的专属动漫追番基地',
  description: '奶片动漫是一个专注于动漫内容的正版在线平台，致力于为每一位动漫爱好者提供优质的追番体验。我们涵盖热门新番、经典老番、国漫、日漫等海量资源，支持高清流畅播放和弹幕互动功能。',
  founded: '2020年',
  email: 'support@naipiananime.com',
  weibo: '@奶片动漫官方',
  wechat: 'naipiananime',
  reputation: [
    { label: '注册用户', value: '500万+', icon: 'ri-user-heart-line' },
    { label: '动漫资源', value: '3000+', icon: 'ri-slideshow-3-line' },
    { label: '日均播放', value: '800万+', icon: 'ri-play-circle-line' },
    { label: '合作版权方', value: '50+', icon: 'ri-group-line' },
  ],
};